// @ts-nocheck

import * as path from 'path'
import { Severity } from '@sentry/types/dist/severity'

export const SEVERITY_LEVELS = {
  [Severity.Debug]: 0,
  [Severity.Info]: 1,
  [Severity.Warning]: 2,
  [Severity.Error]: 3,
  [Severity.Critical]: 4,
  [Severity.Fatal]: 5,
  [Severity.Log]: 6,
}

export default function () {
  // @ts-ignore
  this.addPlugin({
    fileName: 'loggerPlugin.ts',
    src: path.resolve(__dirname, 'loggerPlugin.ts'),
  })

  this.nuxt.hook('render:errorMiddleware', (app) =>
    app.use((err, req, res, next) => {
      const newError = new Error(err)
      const errorMessage = `render:errorMiddleware error : ${err}`
      newError.name = err.name
      newError.stack = err.stack
      Object.keys(err).forEach((propertyKey) => {
        if (!['name', 'stack', 'message'].includes(propertyKey)) {
          newError[propertyKey] = err[propertyKey]
        }
      })
      req.logger
        ? req.logger.error(errorMessage, newError)
        : console.error(errorMessage, newError)

      // this is hacky way to respond failing request with meaningful error message
      if (err instanceof TypeError) {
        res.statusCode = 400
        res.setHeader('Content-Type', 'application/json')
        return res.end(
          JSON.stringify({
            statusCode: 400,
            error: 'Bad request - ' + err.message,
          })
        )
      }

      next(err)
    })
  )
}
